import { GlAvatar, GlAvatarLink, GlSprintf } from '@gitlab/ui';
import { mapActions } from 'pinia';
import { truncateSha } from '~/lib/utils/text_utility';
import { s__, __ } from '~/locale';
import { FILE_DIFF_POSITION_TYPE } from '~/diffs/constants';
import { useNotes } from '~/notes/store/legacy_notes';
import NoteEditedText from './note_edited_text.vue';
import NoteHeader from './note_header.vue';
import ToggleRepliesWidget from './toggle_replies_widget.vue';
export default {
    name: 'DiffDiscussionHeader',
    components: {
        GlAvatar,
        GlAvatarLink,
        GlSprintf,
        NoteEditedText,
        NoteHeader,
        ToggleRepliesWidget
    },
    inject: {
        navigateToDiffNote: {
            default: null
        }
    },
    props: {
        discussion: {
            type: Object,
            required: true
        }
    },
    computed: {
        notes () {
            return this.discussion.notes;
        },
        firstNote () {
            return this.notes[0];
        },
        author () {
            return this.firstNote.author;
        },
        resolvedText () {
            return this.discussion.resolved_by_push ? __('Automatically resolved') : __('Resolved');
        },
        headerMessage () {
            const { for_commit: isForCommit, diff_discussion: isDiffDiscussion, active: isActive, commit_id: commitId, position } = this.discussion;
            if (isForCommit) {
                return s__('MergeRequests|started a thread on commit %{link}');
            }
            if (isDiffDiscussion && commitId) {
                return isActive ? s__('MergeRequests|started a thread on commit %{link}') : s__('MergeRequests|started a thread on an outdated change in commit %{link}');
            }
            if (isDiffDiscussion && position?.position_type === FILE_DIFF_POSITION_TYPE) {
                return isActive ? s__('MergeRequests|started a thread on %{linkStart}a file%{linkEnd}') : s__('MergeRequests|started a thread on %{linkStart}an old version of a file%{linkEnd}');
            }
            if (isDiffDiscussion) {
                return isActive ? s__('MergeRequests|started a thread on %{linkStart}the diff%{linkEnd}') : s__('MergeRequests|started a thread on %{linkStart}an old version of the diff%{linkEnd}');
            }
            return s__('MergeRequests|started a thread');
        },
        isCommitLink () {
            const { for_commit: isForCommit, diff_discussion: isDiffDiscussion, commit_id: commitId } = this.discussion;
            return isForCommit || isDiffDiscussion && commitId;
        },
        truncatedCommitId () {
            return truncateSha(this.discussion.commit_id);
        },
        toggleClass () {
            return this.discussion.expanded ? 'expanded' : 'collapsed';
        },
        replies () {
            return this.notes.filter((note)=>!note.system);
        }
    },
    methods: {
        ...mapActions(useNotes, [
            'toggleDiscussion'
        ]),
        toggleDiscussionHandler () {
            this.toggleDiscussion({
                discussionId: this.discussion.id
            });
        },
        handleDiscussionLinkClick (event) {
            if (!this.navigateToDiffNote) return;
            event.preventDefault();
            this.navigateToDiffNote(this.discussion);
        }
    }
};
